/**
 * @generated SignedSource<<5413ba54cecd85ddc8e767a8a00a793e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecommendedItem_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTile_item" | "RecommendedItemHeart_item" | "recommendedItemTracking_item">;
  readonly " $fragmentType": "RecommendedItem_item";
};
export type RecommendedItem_item$key = {
  readonly " $data"?: RecommendedItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecommendedItem_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendedItem_item",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "recommendedItemTracking_item",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contemporaryTrackingString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendedItemHeart_item"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "showShippingBadge",
          "value": false
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTile_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "35c2dfd67c6cdc171e1b8992ff01ac5e";

export default node;
